import { render, staticRenderFns } from "./DocumentImageEditorModal.vue?vue&type=template&id=2cd1bddd&scoped=true"
import script from "./DocumentImageEditorModal.vue?vue&type=script&lang=js"
export * from "./DocumentImageEditorModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentImageEditorModal.vue?vue&type=style&index=0&id=2cd1bddd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd1bddd",
  null
  
)

export default component.exports